module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-product1.a63b5a64.png";